site.ticker = site.ticker || {};
site.ticker = $.extend(site.ticker, {
	init: function () {
		var body = $('body');
		if ($('.box.eignasafn').length == 0) return false;
		if (site.device.isTouch()) return false;
		var tickerInView = false;
		body.addClass('ticker');

		$(window).scroll(function(){
			if (!tickerInView && site.ticker.isInView($('.box.eignasafn ul'))) {
				tickerInView = true;

				$('.eignasafn li strong').each(function () {
					var num = $(this).text();
					num = num.replace(/\D/g,'');
					$(this).text(Math.ceil(num).toLocaleString().replace(',','.'));
					$(this).parents('li').addClass('counting');
					$(this).css('min-width', $(this).outerWidth(true));
					$(this).text(num);

					$(this).prop('Counter',0).animate({
						Counter: $(this).text()
					}, {
						duration: 2000,
						easing: 'swing',
						step: function (now) {
							$(this).text(Math.ceil(now).toLocaleString().replace(',','.'));
						}
					});
				});
			}
		})
	},
	isInView: function(elem) {
		var docViewTop = $(window).scrollTop();
		var docViewBottom = docViewTop + $(window).height();

		var elemTop = $(elem).offset().top;
		var elemBottom = elemTop + $(elem).height();

		return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
	}
});